module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getSelectedEvent) ? _c('div', [(_vm.user && _vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous incognito mode")]) : _c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    style: (_vm.styleObjectByName),
    attrs: {
      "type": "button",
      "title": "Join event with your first name"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      },
      "click": function($event) {
        return _vm.joinEvent('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('button', {
    style: (_vm.styleObjectCognito),
    attrs: {
      "type": "button",
      "title": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'Join event as incognito' : 'Join event as shoe-cognito'
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverStateCog(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverStateCog(false)
      },
      "click": function($event) {
        return _vm.joinEvent('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.cognitoMsg))])]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('h3', [_vm._v("This event will start " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')) + ". Check back on this page "), (_vm.getSelectedEvent[0].eventSwitchTime && _vm.getSelectedEvent[0].eventSwitchTime > 0) ? _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(" " + _vm._s(_vm.getSelectedEvent[0].eventSwitchTime) + " ")]) : _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getEventSwitchTime))]), _vm._v(" minutes before the event start time and choose how you want to join the event. "), _c('br'), _vm._v("You can join as yourself or step into someone else's shoes using our anonymous incognito mode.")]) : _c('h3', [_vm._v("This event will start " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')) + ". Check back on this page "), (_vm.getSelectedEvent[0].eventSwitchTime && _vm.getSelectedEvent[0].eventSwitchTime > 0) ? _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(" " + _vm._s(_vm.getSelectedEvent[0].eventSwitchTime) + " ")]) : _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getEventSwitchTime))]), _vm._v(" minutes before the event start time and choose how you want to join the event. "), _c('br'), _vm._v("You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": "",
      "title": "Event hasn't started yet"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": "",
      "title": "Event hasn't started yet"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('1')
      }
    }
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span', [_vm._v("Incognito")]) : _c('span', [_vm._v("shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (!_vm.user && _vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [_c('button', {
    style: (_vm.styleObjectByName),
    attrs: {
      "type": "button",
      "title": "Login or Signup to join the event"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      },
      "click": function($event) {
        return _vm.joinEventUnAuth(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v("Go to Event")])]) : _vm._e(), _vm._v(" "), (!_vm.user && !_vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [_c('h3', [_vm._v("This event will start " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')) + ". "), _c('a', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.UnauthSignInClick(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v("Sign In")]), _vm._v(" or "), _c('a', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.UnauthJoinClick(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" to join us for a discussion that will inspire and empower you to be the best version of yourself.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sigup-green-join-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UnauthJoinClick(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.trialButtonTitle))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                Please follow the event guidelines:\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("1.)")]), _vm._v(" Keep it positive, supportive and respectful;\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("2.)")]), _vm._v(" Please be thoughtful and stay on topic;\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("3.)")]), _vm._v(" Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("4.)")]), _vm._v(" Please refer to TONE's "), _c('a', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    attrs: {
      "href": "/terms",
      "target": "new",
      "title": "click to view our terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n            ")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07f96927", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07f96927"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/RulesComp.vue